import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

const STATUS_BADGE = {
  TRIALING: { label: 'Essai', bg: '#eff6ff', color: '#1d4ed8' },
  ACTIVE: { label: 'Actif', bg: '#dcfce7', color: '#166534' },
  PAST_DUE: { label: 'Impayé', bg: '#fef3c7', color: '#92400e' },
  SUSPENDED: { label: 'Suspendu', bg: '#fef2f2', color: '#991b1b' },
};

// Mini vue plateforme (SUPER_ADMIN) : tous les tenants et leur statut.
export default function TenantsSection() {
  const { user } = useAuth();
  const [tenants, setTenants] = useState(null);

  useEffect(() => {
    if (user?.role !== 'SUPER_ADMIN') return;
    api.get('/billing/tenants').then(({ data }) => setTenants(data)).catch(() => {});
  }, [user]);

  if (user?.role !== 'SUPER_ADMIN' || !tenants) return null;

  return (
    <div className="card">
      <h3 style={{ marginBottom: 12 }}>Plateforme — {tenants.length} entreprise{tenants.length > 1 ? 's' : ''}</h3>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', fontSize: '0.82rem', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ textAlign: 'left', color: 'var(--text-light)' }}>
              <th style={{ padding: '4px 8px' }}>Entreprise</th>
              <th style={{ padding: '4px 8px' }}>Plan</th>
              <th style={{ padding: '4px 8px' }}>Statut</th>
              <th style={{ padding: '4px 8px' }}>Mode</th>
              <th style={{ padding: '4px 8px' }}>Membres</th>
              <th style={{ padding: '4px 8px' }}>Chantiers</th>
              <th style={{ padding: '4px 8px' }}>Créée le</th>
            </tr>
          </thead>
          <tbody>
            {tenants.map(t => {
              const st = STATUS_BADGE[t.subscriptionStatus] || {};
              return (
                <tr key={t.id} style={{ borderTop: '1px solid var(--border)' }}>
                  <td style={{ padding: '6px 8px' }}>
                    <a href={`/e/${t.slug}`} target="_blank" rel="noreferrer">{t.name}</a>
                  </td>
                  <td style={{ padding: '6px 8px' }}>{t.plan}</td>
                  <td style={{ padding: '6px 8px' }}>
                    <span style={{ background: st.bg, color: st.color, borderRadius: 99, padding: '2px 8px', fontSize: '0.72rem', fontWeight: 600 }}>
                      {st.label || t.subscriptionStatus}
                    </span>
                  </td>
                  <td style={{ padding: '6px 8px' }}>{t.billingMode === 'CONTRACT' ? 'Contrat' : 'Self-service'}</td>
                  <td style={{ padding: '6px 8px' }}>{t._count.users}</td>
                  <td style={{ padding: '6px 8px' }}>{t._count.projects}</td>
                  <td style={{ padding: '6px 8px' }}>{new Date(t.createdAt).toLocaleDateString('fr-FR')}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
